<template>
    <div class="xc-page xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <a>系统管理</a>
                <a href>品牌管理</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form class="xc-form">
                            <div class="xc-form-inline ele-float">
                                <xc-form-item label="品牌名称:">
                                    <input type="text" placeholder="请输入品牌名称" class="xc-input" name="brandName" v-model="mix_query.brandName" />
                                </xc-form-item>
                                <xc-form-item label="联系人:">
                                    <input type="text" placeholder="请输入联系人" class="xc-input" name="contactPerson" v-model="mix_query.contactPerson" />
                                </xc-form-item>
                                <xc-form-item label="联系方式:">
                                    <input type="text" placeholder="请输入联系方式" class="xc-input" name="phoneNum" v-model="mix_query.phoneNum" />
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button class="xc-btn xc-btn-primary" type="submit" @click.prevent="mix_search">查询</button>
                                    <button class="xc-btn xc-btn-default" type="button" @click.prevent="add">添加</button>
                                    <button type="button" class="xc-btn xc-btn-default" @click.prevent="exportBrand">导出</button>
                                </div>
                            </div>
                        </form>

                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th>编号</th>
                                    <th>品牌名称</th>
                                    <th>联系人</th>
                                    <th>联系方式</th>
                                    <th>地址</th>
                                    <th>创建时间</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr v-for="(item, index) in list" :key="index">
                                        <td>{{index + 1}}</td>
                                        <td>{{item.brandName}}</td>
                                        <td>{{item.contactPerson}}</td>
                                        <td>{{item.phoneNum}}</td>
                                        <td class="text-overflow" :title="item.address">{{item.address}}</td>
                                        <td>{{item.addTimeStr}}</td>
                                        <td>
                                            <xc-btn-select title="管理">
                                                <template v-if="groups.length">
                                                    <xc-btn-select-item
                                                        v-for="obj in groups"
                                                        :key="obj.id"
                                                        :title="obj.name"
                                                        @click.native="mix_action(obj.id, item, $event)"
                                                    ></xc-btn-select-item>
                                                </template>
                                            </xc-btn-select>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="20" class="xc-s-tac">暂无数据</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- 分页 -->
        <div class="xc-page-footer">
            <xc-pagination @change="mix_pageChange" :page="mix_page" :total="mix_total" :size="mix_pageSize" />
        </div>

        <!-- 弹框 -->
        <div class="xc-card">
            <!-- 编辑和添加 -->
            <div class="xc-modal xc-modal-dialog" v-if="modalName == 'addOrEdit'">
                <!-- 遮罩层 -->
                <div class="xc-modal-mask" @click="modalName = null"></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">{{modalTitle}}</div>
                            <div class="xc-modal-close" @click="modalName = null"></div>
                        </div>
                        <div class="xc-modal-body">
                            <form class="xc-form brand" name="addOrEdit" data-vv-scope="addOrEdit">
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="品牌名称:"
                                        required
                                        :error="errors.first('brandName', 'addOrEdit')"
                                    >
                                        <input
                                            type="text"
                                            v-validate="'required'"
                                            data-vv-as="品牌名称"
                                            placeholder="请输入品牌名称"
                                            class="xc-input"
                                            name="brandName"
                                            v-model="modalData.brandName"
                                            :class="{
                                                'xc-input-error': errors.first('brandName', 'addOrEdit')
                                            }"
                                        >
                                    </xc-form-item>
                                    <xc-form-item label="联系人:">
                                        <input type="text" class="xc-input" v-model="modalData.contactPerson" placeholder="请输入联系人">
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item label="联系方式：">
                                        <input type="text" maxlength="11" class="xc-input" v-model="modalData.phoneNum" placeholder="请输入联系方式">
                                    </xc-form-item>
                                </div>
                                <!-- <div class="xc-form-inline address">
                                    <xc-form-item label="详细地址:">
                                        <div class="address-item">
                                            <input class="xc-input xc-input-disabled xc-select-area province" placeholder="省" v-model="modalData.province" type="text" disabled>
                                        </div>
                                        <div class="address-item">
                                            <input class="xc-input xc-input-disabled xc-select-area city" placeholder="市" v-model="modalData.city" type="text" disabled>
                                        </div>
                                        <div class="address-item">
                                            <input class="xc-input xc-input-disabled xc-select-area area" placeholder="区" v-model="modalData.area" type="text" disabled>
                                        </div>
                                    </xc-form-item>
                                </div> -->
                                <div class="xc-form-inline location">
                                    <xc-form-item label="详细地址:">
                                        <input
                                            type="hidden"
                                            name="longitude"
                                            v-model="modalData.longitude"
                                            class="longitude"
                                        />
                                        <input
                                            type="hidden"
                                            name="latitude"
                                            v-model="modalData.latitude"
                                            class="latitude"
                                        />
                                        <input
                                            type="text"
                                            name="storeAdd"
                                            v-model="modalData.address"
                                            class="xc-input  storeAdd xc-input-disabled"
                                            placeholder="请选择详细地址"
                                            disabled
                                        >
                                        <img
                                            class="locationIcon"
                                            @click.prevent="addStreet"
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAaCAMAAADorg53AAAAclBMVEUAAADQ1eHP1uDQ1eHR2ODY2OvQ1eDT2eTP1eDu8vnP1eBXgt/n6/NbheBnjuKku+zc4OqQrenL2PN2meXi6vfY4vXP2/TB0fG3yfCUsOqLqehji+Hd5vbV4PW9zvGswe6HpuhwlOPq7/izxu+dtuuOq+j6g/kYAAAACXRSTlMA8+CBQg3P/tCSivUMAAAA+klEQVQoz43T6a6CQAwF4BkQtBzLDrLIpt73f8ULg8QhsYbza6b5Ugi0ao7n+jr4Gu27njI5OfGVhFxj52TM2RCRnWflOZuRlOMpN7Yr99fEPL3udi121cVu9GSY8NNu5SttXQegSR+PtAEGq6xV8LkUjGo9VeDiUw9sVCMhisIwIkpQCyhERxHmRNQhFBCwwNttAYCAWuQbytEKKEO5Pa5EJqJ0e/FeRBH+tuOIQUAFkL//DjgXEI1I1kOChiTUMer1q3IhIqqAZOmDinZIk52e0YzgflfUyt/PXNoCbbqfOt8MnZ1yysp9JXYPje+RRTi4UmY5L7+X8x/cgCVNeQ3wMQAAAABJRU5ErkJggg=="
                                        />
                                    </xc-form-item>
                                </div>
                            </form>
                        </div>

                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button class="xc-btn xc-btn-default" @click="modalName = null">取消</button>
                                <button class="xc-btn xc-btn-primary" @click="verifyRequired">保存</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "@/libs/vee-validate";
import listMixin from "../xc-ui/mixins/list";
export default {
    name: "BrandManagement",
    mixins: [listMixin],
    data(){
        return {
            adminPath: this.$config.adminPath,
            // 列表key
            mix_listKey: "list",

            // 列表唯一字段
            mix_listId: "id",

            // 列表
            list: [],

            // 默认查询参数
            mix_query: {
                brandName: "",
                contactPerson: "",
                phoneNum: ""
            },

            // 操作时相关的操作
            groups:[{
                id: 0,
                name: "编辑"
            }, {
                id: 1,
                name: "查看节目"
            }, {
                id: 2,
                name: "删除"
            }],

            // 弹框相关
            // 编辑和添加框中的数据
            modalData:{},
            // 弹框名称
            modalName:null,
            // 弹框标题
            modalTitle:"",
        }
    },
    created(){
        let _this = this;
        // 全局方法，暴露address对象
        window.initAddress = function (params) {
            // console.log(params)
            let address = `${params.province}${params.city}${params.area}${params.storeAdd}`;
            _this.modalData = {..._this.modalData, address};
            // console.log(_this.modalData, "modalData")
        }
    },
    methods:{
        // 初始化数据
        initData(){
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query
            };
            this.$http.post("/brand/list", JSON.stringify(search), {
                headers: {
                    'Content-Type': 'application/json'
                },
            }).then(res => {
                this[this.mix_listKey] = res.data.list;
                this.mix_total = res.data.total;
                this.mix_page = res.data.pageNum;
                this.mix_pageSize = res.data.pageSize;
            });
        },

        // 相关的操作
        action(...arg){
            // console.log(arg, "arg")
            const [id, data, $event] = arg;
            switch(id){
                case 0:
                    this.modalTitle = "编辑";
                    this.modalName = "addOrEdit";
                    console.log(data, "编辑data");
                    this.modalData = {...data};
                    break;
                case 1:
                    localStorage.pageId = 16;
                    localStorage.pageParentId = 2;
                    if (localStorage.token) {
                        this.$store.dispatch("getUserModule");
                    }
                    this.$router.push({path: this.adminPath + '/program', query: {brandId: data.brandId}});
                    break;
                case 2:
                    this.$xc.confirm({
                        title: "温馨提示",
                        msg: "确定删除该品牌？"
                    }).then(() => {
                        this.$http.post("/brand/del", JSON.stringify({brandId: data.brandId}), {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            showLoading: "删除中..."
                        }).then(res => {
                            this.$message.success(res.msg);
                            this.initData();
                        })
                    })
                    break;
            }
        },

        // 验证是否又必填字段
        verifyRequired(){
            const scope = "addOrEdit";
            this.$validator.validateAll(scope).then(validate => {
                console.log(validate, "validate");
                if(validate){
                    this.addSubmit();
                }else{
                    let error = this.errors.items[0].msg;
                    return false;
                }
            })
        },

        // 添加地址
        addStreet(){
            console.log("打开地图");
            console.log(this.adminPath, "adminPath");
            this.$nextTick(function (){
                myLayer.open({
                    type: 2,
                    title: false,
                    closeBtn: 0,
                    content: this.adminPath + "/system/map",
                    success: function (layero) {
                        var iframeWin = window[layero.find('iframe')[0]['name']];//得到iframe页的窗口对象
                    },
                })
            })
        },

        // 添加品牌
        add(){
            console.log("添加");
            this.modalTitle = "添加";
            this.modalName = "addOrEdit";
            this.modalData = {};
        },

        // 保存品牌
        addSubmit(){
            if(this.modalTitle === "编辑"){
                this.$http.post("/brand/edit", JSON.stringify(this.modalData), {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    showLoading: "提交中..."
                }).then(res => {
                    this.$message.success(res.msg);
                    this.modalName = "";
                    this.initData();
                })
            }else if(this.modalTitle === "添加"){
                this.$http.post("/brand/add", JSON.stringify(this.modalData), {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    showLoading: "提交中..."
                }).then(res => {
                    this.$message.success(res.msg);
                    this.modalName = "";
                    this.initData();
                })
            }
        },

        // 导出
        exportBrand(){
            console.log("导出");
            this.$http.get("/brand/exportBrandExcel", {
                responseType: 'blob',
                showLoading: "导出中...",
                params:{
                    ...this.mix_query
                }
            }).then(v => {
                console.log(v ,"v");
                let url = window.URL.createObjectURL(new Blob([v]));
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", "品牌列表.xlsx");
                document.body.appendChild(link);
                link.click();
                // 释放掉blob对象
                window.URL.revokeObjectURL(url);
            })
        }
    }
}
</script>

<style lang="scss">
.brand{
    .address {
        .xc-form-item-content {
            display: flex;
        }
        .xc-select-area {
            width: 113px;
            margin-right: 17px;
        }
        .address-item:last-child{
            .xc-select-area{
                margin-right: 0px;
            }
        }
    }
    .location {
        .xc-form-item-content {
            position: relative;
            .storeAdd {
                width: 373px !important;
            }
            .locationIcon {
                position: absolute;
                right: 3px;
                top: 3px;
                display: block;
                width: 36px;
                height: 26px;
            }
        }
    }
}

// 文字超出隐藏
.text-overflow{
    max-width: 25em;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>